export const UI_NAME = 'ui-tag';

export const KIND_DEFAULT = 'default';
export const KIND_PRIMARY = 'primary';
export const KIND_SECONDARY = 'secondary';
export const KIND_SUCCESS = 'success';
export const KIND_INFO = 'info';
export const KIND_WARNING = 'warning';
export const KIND_DANGER = 'danger';

export const KINDS = [
  KIND_DEFAULT,
  KIND_PRIMARY,
  KIND_SECONDARY,
  KIND_SUCCESS,
  KIND_INFO,
  KIND_WARNING,
  KIND_DANGER
];

export const SIZE_SMALL = 'small';
export const SIZE_MEDIUM = 'medium';
export const SIZE_LARGE = 'large';

export const SIZES = [SIZE_SMALL, SIZE_MEDIUM, SIZE_LARGE];
